"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicApi = exports.scrapi = exports.PUBLIC_API_PREFIX = exports.SCRAPI_V1_PREFIX = void 0;
const core_1 = require("@ts-rest/core");
const routers_1 = require("./routers");
exports.SCRAPI_V1_PREFIX = '/scrapi/v1';
exports.PUBLIC_API_PREFIX = '/api/v1';
exports.scrapi = (0, core_1.initContract)().router({
    auth: routers_1.auth,
    folders: routers_1.folders.privateRouter,
    rundowns: routers_1.rundowns.privateRouter,
    scripts: routers_1.scripts.privateRouter,
    users: routers_1.users.privateRouter,
    staff: routers_1.staff,
    workspaces: routers_1.workspaces.privateRouter,
}, {
    pathPrefix: exports.SCRAPI_V1_PREFIX,
    // this ensures that dates are de-serialized appropriately
    // on the client side and show up as Date objects intead of
    // ISO-formatted strings. Basically the zod validators are run on the
    // raw payloads for all data returned to the client and if they don't
    // conform, a ZodError is thrown
    validateResponseOnClient: true,
});
exports.publicApi = (0, core_1.initContract)().router({
    folders: routers_1.folders.publicRouter,
    rundowns: routers_1.rundowns.publicRouter,
    scripts: routers_1.scripts.publicRouter,
    users: routers_1.users.publicRouter,
    workspaces: routers_1.workspaces.publicRouter,
}, {
    pathPrefix: exports.PUBLIC_API_PREFIX,
});
